import type { SelectorCreator, Slicer } from '@swf/core/store';

import type { SportsMenuState } from './types';

export const selectors = (slice: Slicer<SportsMenuState>, createSelector: SelectorCreator) => ({
  az: () => slice((state) => state.az),
  azErrorCode: () => slice((state) => state.azErrorCode),
  popular: () => slice((state) => state.popular),
  hasPreloaded: () => slice((state) => state.preloaded)
});
